module.exports = __webpack_public_path__ + "assets/img/image(4).4fe5caf8.png";